// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bs_c0","inline":"bs_dM","inlineBlock":"bs_dN","quote":"bs_dP","icon":"bs_dQ","medium":"bs_dR","big":"bs_dS","large":"bs_dT"};